export const transparencia_item = [
    {
        "anio" : "2025",
        "descripcion" : "",
        "ligas" : [
    
            {
                "transparencia_item_nombre" : "Art. 69 Ley de Transparencia (48 Rubros)",
                "transparencia_item_url" : "Rubros"
            },
            {
                "transparencia_item_nombre" : "Art. 70 Ley de Transparencia",
                "transparencia_item_url" : "../Articulo70"
            },
            {
                "transparencia_item_nombre" : "Programa Operativo Anual 2026 (POA)",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/POA_2026.pdf"
            },
            {
                "transparencia_item_nombre" : "Programa Operativo Anual 2025 (POA)",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/POA_2025.pdf"
            },
            {
                "transparencia_item_nombre" : "Padrón de Beneficiarios del Apoyo al Autoempleo 4T 2025",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/Padron_Beneficiarios_Apoyo_Autoempleo_4T_2025.pdf"
            },
            {
                "transparencia_item_nombre" : "Padrón de Beneficiarios del Apoyo Especialización para la Empleabilidad 4T 2025",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/Padron_Beneficiarios_Apoyo_Especializacion_Empleabilidad_4T_2025.pdf"
            },
            {
                "transparencia_item_nombre" : "Padrón de Beneficiarios del Apoyo Impulso a la Movilidad Laboral 4T 2025",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/Padron_Beneficiarios_Apoyo_Impulso_Movilidad_Laboral_4T_2025.pdf"
            },
            {
                "transparencia_item_nombre" : "Consulta de Sindicatos",
                "transparencia_item_url" : "http://justicialaboral.hidalgo.gob.mx/st/publicacion/colectivos/"
            },
            {
                "transparencia_item_nombre" : "Consulta de Contratos Colectivos",
                "transparencia_item_url" : "http://justicialaboral.hidalgo.gob.mx/st/publicacion/contratos/"
            },
            {
                "transparencia_item_nombre" : "Agenda del Secretario",
                "transparencia_item_url" : "../Agenda"
            },
            {
                "transparencia_item_nombre" : "Programa Anual de Adquisiciones",
                "transparencia_item_url" : "../Paaas"
            },
            {
                "transparencia_item_nombre" : "Programa Operativo Anual 2024 (POA)",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/POA_2024.pdf"
            },
            {
                "transparencia_item_nombre" : "Padrón de Beneficiarios del Programa Fortalecimiento de la Vinculación y Movilidad Laboral, Primero el Pueblo 2025",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/PADRON_PRIMERO_PUEBLO_2025.pdf"
            },
            {
                "transparencia_item_nombre" : "Padrón de Beneficiarios del Programa Fortalecimiento de la Vinculación y Movilidad Laboral, Primero el Pueblo 2024",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/PADRON_PRIMERO_PUEBLO_2024.pdf"
            },
            {
                "transparencia_item_nombre" : "Padrón de Beneficiarios del Programa Fortalecimiento de la Vinculación y Movilidad Laboral, Primero el Pueblo 2023",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/PADRON_PRIMERO_PUEBLO_2023.pdf"
            },
            {
                "transparencia_item_nombre" : "Programa Anual de Desarrollo Archivístico 2023",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/PROGRAMA_ANUAL_ARCHIVO.pdf"
            },
            {
                "transparencia_item_nombre" : "Informe Anual de Resultados Archivístico 2022",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/INFORME_ANUAL_ARCHIVO_2022.pdf"
            },
            {
                "transparencia_item_nombre" : "Informe Anual de Resultados Archivístico 2023",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/INFORME_ANUAL_ARCHIVO_2023.pdf"
            },
            {
                "transparencia_item_nombre" : "Programa Anual de Desarrollo Archivístico 2024",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/PADA_2024.pdf"
            },
            {
                "transparencia_item_nombre" : "Padrón de Beneficiarios Especialización para la Empleabilidad 2do Trimestre 2024",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/BENEFICIARIOS_ESPECIALIZACION_EMPLEABILIDAD_2T_2024.pdf"
            },
            {
                "transparencia_item_nombre" : "Padrón de Beneficiarios Impulso a la Movilidad Laboral 2do Trimestre 2024",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/BENEFICIARIOS_MOVILIDAD_LABORAL_2T_2024.pdf"
            },
            {
                "transparencia_item_nombre" : "Padrón de Beneficiarios Especialización para la Empleabilidad 3er Trimestre 2024",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/BENEFICIARIOS_ESPECIALIZACION_EMPLEABILIDAD_3T_2024.pdf"
            },
            {
                "transparencia_item_nombre" : "Padrón de Beneficiarios Impulso a la Movilidad Laboral 3er Trimestre 2024",
                "transparencia_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/BENEFICIARIOS_MOVILIDAD_LABORAL_3T_2024.pdf"
            }
        ]
    }
]